module.exports = __webpack_public_path__ + "public/img/Mengelola Kinerja Karyawan Untuk Menjadi Manajer Sumber Daya Manusia.f361e4cf.png";